import { ConfigProvider } from 'antd';
import { dictionaryList } from 'languages';
import { createContext, useEffect, useState } from 'react';
import { formatUserLanguage } from 'utils/language/formatUserLanguage';
import { formatUserLocale } from 'utils/language/formatUserLocale';
import enUS from 'antd/es/locale/en_US';
import esES from 'antd/es/locale/es_ES';
import ptBR from 'antd/es/locale/pt_BR';

export const LanguageContext = createContext({
	userLanguage: 'en',
	userLocale: 'en-US',
	dictionary: dictionaryList.en,
});

export function LanguageProvider({ children }) {
	const [userLanguage, setUserLanguage] = useState('en');
	const [userLocale, setUserLocale] = useState('en-US');
	const [dictionary, setDictionary] = useState(dictionaryList.en);

	useEffect(() => {
		function changeLanguage() {
			window.BX24.init(async () => {
				if (window.BX24) {
					const bitrix24Language = window.BX24.getLang();

					const bitrix24LanguageFormatted = formatUserLanguage(bitrix24Language);

					setUserLanguage(bitrix24LanguageFormatted);
					setUserLocale(formatUserLocale(bitrix24LanguageFormatted));
					setDictionary(dictionaryList[bitrix24LanguageFormatted]);
				}
			});
		}
		changeLanguage();
	}, []);

	function getUserLocale() {
		switch (userLocale) {
			case 'pt-BR':
				return ptBR;
			case 'es-ES':
				return esES;
			default:
				return enUS;
		}
	}

	return (
		<LanguageContext.Provider value={{ userLanguage, userLocale, dictionary }}>
			<ConfigProvider locale={getUserLocale()}>{children}</ConfigProvider>
		</LanguageContext.Provider>
	);
}
